<template>
  <VDialogV3
    position="center"
    width="500px"
    :loading="false"
    :title="$core.utils.string.capitalize(title)"
    hide-footer
  >
    <section class="reports-loading">
      <div class="text">
        Идет {{ title }}, ожидайте...
      </div>
      <div class="loader">
        <div class="loader-dash" />
      </div>
    </section>
  </VDialogV3>
</template>

<style lang="scss" src="./ReportsLoadingDialog.scss"/>

<script>

export default {
	name:   'ReportsLoadingDialog',

	props:  {
		title: {
			type:     String,
			default:  'Загрузка',
			required: false,
		},
	},
};
</script>
